export const LogoAnimationData = (color = '#000d6e') => ({
    v: '5.9.4',
    fr: 25,
    ip: 0,
    op: 49,
    w: 2500,
    h: 550,
    asdf: color,
    nm: 'BAL_Logo_for_Code',
    ddd: 0,
    assets: [
        {
            id: 'comp_0',
            nm: 'Shapes_Logo',
            fr: 25,
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 0,
                    nm: 'shape',
                    refId: 'comp_1',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [1280, 1272, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [1280, 1280, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    w: 2560,
                    h: 2560,
                    ip: 0,
                    op: 88,
                    st: 0,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 0,
                    nm: 'shape',
                    refId: 'comp_1',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [1288, 1280, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [1280, 1280, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    w: 2560,
                    h: 2560,
                    ip: 0,
                    op: 88,
                    st: 0,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 0,
                    nm: 'shape',
                    refId: 'comp_1',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [1284, 1276, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [1280, 1280, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    w: 2560,
                    h: 2560,
                    ip: 0,
                    op: 88,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_1',
            nm: 'shape',
            fr: 25,
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 0,
                    nm: 'shape rotate',
                    refId: 'comp_2',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [1280, 1280, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [1280, 1280, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    w: 2560,
                    h: 2560,
                    ip: 0,
                    op: 88,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_2',
            nm: 'shape rotate',
            fr: 25,
            layers: [
                {
                    ddd: 0,
                    ind: 2,
                    ty: 3,
                    nm: 'Null 8',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 0, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [2360, 2000.036, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 69,
                                    s: [100, 100, 100],
                                },
                                { t: 70, s: [81.2, 100, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    ip: 20,
                    op: 88,
                    st: 0,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 4,
                    nm: 'Maske Icon Outlines 8',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 45, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 21,
                                    s: [1321.125, 1281, 0],
                                    to: [-4, 0, 0],
                                    ti: [6.667, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 22,
                                    s: [1297.125, 1281, 0],
                                    to: [-6.667, 0, 0],
                                    ti: [2.667, 0, 0],
                                },
                                { t: 24, s: [1281.125, 1281, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [426.41, 548.828, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [1104, 1104, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [4.479, 4.479],
                                                [0, 0],
                                                [4.479, -4.48],
                                                [0, 0],
                                                [-4.479, -4.479],
                                                [0, 0],
                                                [-4.479, 4.48],
                                            ],
                                            o: [
                                                [4.479, -4.479],
                                                [0, 0],
                                                [-4.479, -4.48],
                                                [0, 0],
                                                [-4.479, 4.479],
                                                [0, 0],
                                                [4.479, 4.48],
                                                [0, 0],
                                            ],
                                            v: [
                                                [130.113, 8.111],
                                                [130.113, -8.11],
                                                [8.11, -130.112],
                                                [-8.11, -130.112],
                                                [-130.113, -8.11],
                                                [-130.113, 8.111],
                                                [-8.11, 130.113],
                                                [8.11, 130.113],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [426.41, 548.828], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 20,
                    op: 88,
                    st: -60,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 4,
                    ty: 4,
                    nm: 'Shape Layer 1',
                    parent: 2,
                    tt: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 20,
                                    s: [-360, -720.036, 0],
                                    to: [0, 120, 0],
                                    ti: [0, -120, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 24,
                                    s: [-360, -0.036, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 53,
                                    s: [-360, -0.036, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 65,
                                    s: [-360, -0.036, 0],
                                    to: [60, 60, 0],
                                    ti: [-0.006, -0.006, 0],
                                },
                                { t: 66, s: [-359.964, 0, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [-387.395, -327.395, 0], ix: 1, l: 2 },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 21,
                                    s: [74.66, 66.66, 100],
                                },
                                { t: 23, s: [66.66, 66.66, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-387.395, -327.395], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 20,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 5,
                    ty: 4,
                    nm: 'Maske Icon Outlines 7',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 45, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 0.734 },
                                    o: { x: 0.333, y: 0 },
                                    t: 15,
                                    s: [561.125, 1281, 0],
                                    to: [26.056, 0, 0],
                                    ti: [-72.498, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 0.929 },
                                    o: { x: 0.333, y: 0.043 },
                                    t: 16,
                                    s: [479.675, 1169, 0],
                                    to: [95.006, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0.388 },
                                    t: 17,
                                    s: [1530.166, 1165, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 0.753 },
                                    o: { x: 0.333, y: 0 },
                                    t: 19,
                                    s: [1153.125, 1233, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0.232 },
                                    t: 21,
                                    s: [1186.685, 1281.581, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 24, s: [1281.125, 1281, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [426.41, 548.828, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [1104, 1104, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [4.479, 4.479],
                                                [0, 0],
                                                [4.479, -4.48],
                                                [0, 0],
                                                [-4.479, -4.479],
                                                [0, 0],
                                                [-4.479, 4.48],
                                            ],
                                            o: [
                                                [4.479, -4.479],
                                                [0, 0],
                                                [-4.479, -4.48],
                                                [0, 0],
                                                [-4.479, 4.479],
                                                [0, 0],
                                                [4.479, 4.48],
                                                [0, 0],
                                            ],
                                            v: [
                                                [130.113, 8.111],
                                                [130.113, -8.11],
                                                [8.11, -130.112],
                                                [-8.11, -130.112],
                                                [-130.113, -8.11],
                                                [-130.113, 8.111],
                                                [-8.11, 130.113],
                                                [8.11, 130.113],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [426.41, 548.828], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 15,
                    op: 88,
                    st: -60,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 6,
                    ty: 4,
                    nm: 'Shape Layer 2',
                    tt: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 15,
                                    s: [1280, 920, 0],
                                    to: [-120, 0, 0],
                                    ti: [120, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 19,
                                    s: [560, 920, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 63,
                                    s: [560, 920, 0],
                                    to: [-60, -120, 0],
                                    ti: [60, 120, 0],
                                },
                                { t: 64, s: [200, 200, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 63,
                                    s: [-387.395, 212.605, 0],
                                    to: [-90, -180, 0],
                                    ti: [90, 180, 0],
                                },
                                { t: 64, s: [-927.395, -867.395, 0] },
                            ],
                            ix: 1,
                            l: 2,
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.4, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 15,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.727, 0.478, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0.273, 0, 0] },
                                    t: 16,
                                    s: [70.307, 78.33, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0.6, 0.343, 0] },
                                    t: 18,
                                    s: [86.353, 74, 100],
                                },
                                {
                                    i: { x: [0.663, 0.663, 0.663], y: [0.384, 0.67, 1] },
                                    o: { x: [0.328, 0.328, 0.328], y: [0, 0, 0] },
                                    t: 19,
                                    s: [90, 70.7, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.612, 0.7, 1] },
                                    o: { x: [0.332, 0.332, 0.332], y: [0.258, 0.734, 0] },
                                    t: 20,
                                    s: [87.644, 67.9, 100],
                                },
                                {
                                    i: { x: [0.696, 0.696, 0.696], y: [1, 1, 1] },
                                    o: { x: [0.35, 0.35, 0.35], y: [0.438, -1.172, 0] },
                                    t: 21,
                                    s: [82.105, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 24,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.899, 0.429, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 64,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [-0.928, 0.238, 0] },
                                    t: 66,
                                    s: [166.29, 64.778, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 69,
                                    s: [150, 58, 100],
                                },
                                { t: 76, s: [150, 59.4, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-387.395, -327.395], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 15,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 7,
                    ty: 4,
                    nm: 'Maske Icon Outlines',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 45, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 19,
                                    s: [1757.125, 1473, 0],
                                    to: [-58.505, -16.716, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 23,
                                    s: [1147.324, 1335.959, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 25,
                                    s: [1197.125, 1281, 0],
                                    to: [0, 0, 0],
                                    ti: [-14, 0, 0],
                                },
                                { t: 28, s: [1281.125, 1281, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [426.41, 548.828, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [1104, 1104, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [4.479, 4.479],
                                                [0, 0],
                                                [4.479, -4.48],
                                                [0, 0],
                                                [-4.479, -4.479],
                                                [0, 0],
                                                [-4.479, 4.48],
                                            ],
                                            o: [
                                                [4.479, -4.479],
                                                [0, 0],
                                                [-4.479, -4.48],
                                                [0, 0],
                                                [-4.479, 4.479],
                                                [0, 0],
                                                [4.479, 4.48],
                                                [0, 0],
                                            ],
                                            v: [
                                                [130.113, 8.111],
                                                [130.113, -8.11],
                                                [8.11, -130.112],
                                                [-8.11, -130.112],
                                                [-130.113, -8.11],
                                                [-130.113, 8.111],
                                                [-8.11, 130.113],
                                                [8.11, 130.113],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [426.41, 548.828], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 19,
                    op: 88,
                    st: -60,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 8,
                    ty: 4,
                    nm: 'Shape Layer 3',
                    tt: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 19,
                                    s: [1280, 1640, 0],
                                    to: [-120, 0, 0],
                                    ti: [120, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 23,
                                    s: [560, 1640, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 65,
                                    s: [560, 1640, 0],
                                    to: [0, 120, 0],
                                    ti: [0, -120, 0],
                                },
                                { t: 66, s: [560, 2360, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 65,
                                    s: [-387.395, -867.395, 0],
                                    to: [0, 180, 0],
                                    ti: [0, -180, 0],
                                },
                                { t: 66, s: [-387.395, 212.605, 0] },
                            ],
                            ix: 1,
                            l: 2,
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.4, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 19,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.636, 0.013, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0.273, 0, 0] },
                                    t: 20,
                                    s: [70.307, 78.33, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0.5, 0.349, 0] },
                                    t: 21,
                                    s: [78.33, 77.2, 100],
                                },
                                {
                                    i: { x: [0.663, 0.663, 0.663], y: [0.384, 0.661, 1] },
                                    o: { x: [0.328, 0.328, 0.328], y: [0, 0, 0] },
                                    t: 23,
                                    s: [90, 70.8, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [0.612, 0.715, 1] },
                                    o: { x: [0.332, 0.332, 0.332], y: [0.258, 0.696, 0] },
                                    t: 24,
                                    s: [87.644, 68, 100],
                                },
                                {
                                    i: { x: [0.696, 0.696, 0.696], y: [1, 1, 1] },
                                    o: { x: [0.35, 0.35, 0.35], y: [0.438, -1.201, 0] },
                                    t: 25,
                                    s: [82.105, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 28,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 66,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 71,
                                    s: [66.66, 55.2, 100],
                                },
                                { t: 75, s: [66.66, 59.4, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-387.395, -327.395], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 19,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 9,
                    ty: 4,
                    nm: 'Shape Layer 5',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 16,
                                    s: [1280, 1280, 0],
                                    to: [0, 0, 0],
                                    ti: [0, -120, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 20,
                                    s: [1280, 2000, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 41,
                                    s: [1280, 2000, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 47,
                                    s: [1280, 1216, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 52,
                                    s: [1280, 1280, 0],
                                    to: [0, 0, 0],
                                    ti: [0, -153.935, 0],
                                },
                                { t: 53, s: [1280, 1280, 0], h: 1 },
                                {
                                    t: 63,
                                    s: [1280, 1280, 0],
                                    h: 1,
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 64,
                                    s: [1280, 1280, 0],
                                    to: [0, 230.274, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 65,
                                    s: [1406, 1281.12, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 71,
                                    s: [1406, 2061.92, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 75, s: [1406, 2039.24, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 64,
                                    s: [-387.395, -327.395, 0],
                                    to: [-90, 90, 0],
                                    ti: [90, -90, 0],
                                },
                                { t: 65, s: [-387.395, -327.395, 0] },
                            ],
                            ix: 1,
                            l: 2,
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
                                    t: 16,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 20,
                                    s: [66.66, 90, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 25,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 41,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 42,
                                    s: [66.66, 67.2, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 52,
                                    s: [66.66, 67.2, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 64,
                                    s: [66.66, 67.2, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 65,
                                    s: [90, 67.2, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 71,
                                    s: [90, 55.2, 100],
                                },
                                { t: 75, s: [90, 59.4, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-387.395, -327.395], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 16,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 10,
                    ty: 4,
                    nm: 'shape',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 40,
                                    s: [920, 920, 0],
                                    to: [-60, 0, 0],
                                    ti: [60, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 48,
                                    s: [200, 920, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 65,
                                    s: [200, 352, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 69, s: [200, 760, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [-791.483, -475.483, 0], ix: 1, l: 2 },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 48,
                                    s: [86, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 65,
                                    s: [66.66, 50, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 68,
                                    s: [59.4, 40, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 71,
                                    s: [58, 62, 100],
                                },
                                { t: 75, s: [59.4, 50.66, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-251.483, 64.517], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 65,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 11,
                    ty: 4,
                    nm: 'Maske Icon Outlines 10',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 45, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 19,
                                    s: [1909.125, 1473, 0],
                                    to: [-58.505, -16.716, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 23,
                                    s: [1299.324, 1335.959, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 25,
                                    s: [1349.125, 1281, 0],
                                    to: [0, 0, 0],
                                    ti: [-14, 0, 0],
                                },
                                { t: 28, s: [1433.125, 1281, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [426.41, 548.828, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [1104, 1104, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [4.479, 4.479],
                                                [0, 0],
                                                [4.479, -4.48],
                                                [0, 0],
                                                [-4.479, -4.479],
                                                [0, 0],
                                                [-4.479, 4.48],
                                            ],
                                            o: [
                                                [4.479, -4.479],
                                                [0, 0],
                                                [-4.479, -4.48],
                                                [0, 0],
                                                [-4.479, 4.479],
                                                [0, 0],
                                                [4.479, 4.48],
                                                [0, 0],
                                            ],
                                            v: [
                                                [130.113, 8.111],
                                                [130.113, -8.11],
                                                [8.11, -130.112],
                                                [-8.11, -130.112],
                                                [-130.113, -8.11],
                                                [-130.113, 8.111],
                                                [-8.11, 130.113],
                                                [8.11, 130.113],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [426.41, 548.828], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 14,
                    op: 88,
                    st: -60,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 12,
                    ty: 4,
                    nm: 'Shape Layer 4',
                    tt: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 14,
                                    s: [1280, 1280, 0],
                                    to: [120, 0, 0],
                                    ti: [-120, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 18,
                                    s: [2000, 1280, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.653, y: 0.653 },
                                    o: { x: 0.298, y: 0.298 },
                                    t: 36,
                                    s: [2000, 1280, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.334, y: 0.334 },
                                    t: 45,
                                    s: [2000, 1280, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.333, y: 0 },
                                    t: 60,
                                    s: [2000, 1280, 0],
                                    to: [60, 0, 0],
                                    ti: [-60, 0, 0],
                                },
                                {
                                    i: { x: 0.638, y: 0.757 },
                                    o: { x: 0.293, y: 0 },
                                    t: 61,
                                    s: [2000.036, 1280, 0],
                                    to: [0.512, 0, 0],
                                    ti: [-0.174, 0, 0],
                                },
                                {
                                    i: { x: 0.668, y: 0.095 },
                                    o: { x: 0.327, y: 0.368 },
                                    t: 62,
                                    s: [1997.044, 1280, 0],
                                    to: [0.871, 0, 0],
                                    ti: [1.145, 0, 0],
                                },
                                {
                                    i: { x: 0.759, y: 0 },
                                    o: { x: 0.354, y: 0.604 },
                                    t: 63,
                                    s: [1997.935, 1280, 0],
                                    to: [-1.527, 0, 0],
                                    ti: [3.187, 0, 0],
                                },
                                {
                                    i: { x: 0.82, y: 0.526 },
                                    o: { x: 0.454, y: 0.194 },
                                    t: 64,
                                    s: [1998.032, 1280, 0],
                                    to: [-8.943, 0, 0],
                                    ti: [-27.873, 0, 0],
                                },
                                {
                                    i: { x: 0.65, y: 0.379 },
                                    o: { x: 0.169, y: 1 },
                                    t: 65,
                                    s: [2000.036, 1280, 0],
                                    to: [31.212, 0, 0],
                                    ti: [-23.631, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.414, y: 0.616 },
                                    t: 67,
                                    s: [2022.679, 1280, 0],
                                    to: [22.595, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 70,
                                    s: [2068.4, 1280, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 76, s: [2039.24, 1280, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [-387.395, -327.395, 0], ix: 1, l: 2 },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0, 0] },
                                    t: 14,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 18,
                                    s: [90, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 23,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 45,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 61,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 65,
                                    s: [66.66, 66.66, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 70,
                                    s: [54, 90.66, 100],
                                },
                                { t: 76, s: [59.4, 90, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-387.395, -327.395], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 14,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 13,
                    ty: 4,
                    nm: 'Maske Icon Outlines 9',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 45, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 17,
                                    s: [558.268, 1169, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 18,
                                    s: [559.601, 1221.003, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 19,
                                    s: [560.935, 1235.002, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 20,
                                    s: [562.268, 1265, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 21,
                                    s: [562.268, 1281, 0],
                                    to: [0, 0, 0],
                                    ti: [-0.015, 0.125, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 39,
                                    s: [563.86, 1281, 0],
                                    to: [-5.401, 0, 0],
                                    ti: [-2.404, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 41,
                                    s: [490.268, 1281, 0],
                                    to: [33.161, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 47,
                                    s: [1401.125, 1281, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 52, s: [1281.125, 1281, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [426.41, 548.828, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [1104, 1104, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [4.479, 4.479],
                                                [0, 0],
                                                [4.479, -4.48],
                                                [0, 0],
                                                [-4.479, -4.479],
                                                [0, 0],
                                                [-4.479, 4.48],
                                            ],
                                            o: [
                                                [4.479, -4.479],
                                                [0, 0],
                                                [-4.479, -4.48],
                                                [0, 0],
                                                [-4.479, 4.479],
                                                [0, 0],
                                                [4.479, 4.48],
                                                [0, 0],
                                            ],
                                            v: [
                                                [130.113, 8.111],
                                                [130.113, -8.11],
                                                [8.11, -130.112],
                                                [-8.11, -130.112],
                                                [-130.113, -8.11],
                                                [-130.113, 8.111],
                                                [-8.11, 130.113],
                                                [8.11, 130.113],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [426.41, 548.828], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 12,
                    op: 88,
                    st: -60,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 14,
                    ty: 4,
                    nm: 'shape 2',
                    tt: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 12,
                                    s: [920, 1280, 0],
                                    to: [0, -120, 0],
                                    ti: [-120, -40, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 16,
                                    s: [920, 560, 0],
                                    to: [120, 40, 0],
                                    ti: [-81.504, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 46,
                                    s: [1640, 1520, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 65, s: [1640, 1520, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [-791.483, 64.517, 0], ix: 1, l: 2 },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
                                    t: 12,
                                    s: [66.66, 66.6, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 16,
                                    s: [66.66, 90, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [-1.082, 1, 1] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0] },
                                    t: 21,
                                    s: [66.66, 66.8, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0.625, 0, 0] },
                                    t: 46,
                                    s: [76.667, 160, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 47,
                                    s: [78, 160, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 52,
                                    s: [66.6, 160, 100],
                                },
                                { t: 65, s: [66.6, 66.8, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-251.483, 64.517], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 46,
                    op: 53,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 15,
                    ty: 4,
                    nm: 'Maske Icon Outlines 3',
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 45, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 17,
                                    s: [558.268, 1169, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 18,
                                    s: [559.601, 1221.003, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 19,
                                    s: [560.935, 1235.002, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 20,
                                    s: [562.268, 1265, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 21,
                                    s: [562.268, 1281, 0],
                                    to: [0, 0, 0],
                                    ti: [-0.015, 0.125, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 39,
                                    s: [563.86, 1281, 0],
                                    to: [-5.401, 0, 0],
                                    ti: [-2.404, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 41,
                                    s: [490.268, 1281, 0],
                                    to: [33.161, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 47,
                                    s: [1401.125, 1281, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                { t: 52, s: [1281.125, 1281, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [426.41, 548.828, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [1104, 1104, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [4.479, 4.479],
                                                [0, 0],
                                                [4.479, -4.48],
                                                [0, 0],
                                                [-4.479, -4.479],
                                                [0, 0],
                                                [-4.479, 4.48],
                                            ],
                                            o: [
                                                [4.479, -4.479],
                                                [0, 0],
                                                [-4.479, -4.48],
                                                [0, 0],
                                                [-4.479, 4.479],
                                                [0, 0],
                                                [4.479, 4.48],
                                                [0, 0],
                                            ],
                                            v: [
                                                [130.113, 8.111],
                                                [130.113, -8.11],
                                                [8.11, -130.112],
                                                [-8.11, -130.112],
                                                [-130.113, -8.11],
                                                [-130.113, 8.111],
                                                [-8.11, 130.113],
                                                [8.11, 130.113],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [426.41, 548.828], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 12,
                    op: 88,
                    st: -60,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 16,
                    ty: 4,
                    nm: 'Shape Layer 7',
                    tt: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 12,
                                    s: [920, 1280, 0],
                                    to: [0, -120, 0],
                                    ti: [0, 120, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 16,
                                    s: [920, 560, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 0.717 },
                                    o: { x: 0.333, y: 0 },
                                    t: 41,
                                    s: [920, 560, 0],
                                    to: [38.496, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.333, y: 0.206 },
                                    t: 42.75,
                                    s: [1122.862, 560, 0],
                                    to: [0, 0, 0],
                                    ti: [-81.504, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 46,
                                    s: [1640, 560, 0],
                                    to: [0, 0, 0],
                                    ti: [0, 0, 0],
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 65,
                                    s: [1640, 560, 0],
                                    to: [120, -60, 0],
                                    ti: [-120, 60, 0],
                                },
                                { t: 66, s: [2360, 200, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 65,
                                    s: [-927.395, -327.395, 0],
                                    to: [180, -90, 0],
                                    ti: [-180, 90, 0],
                                },
                                { t: 66, s: [152.605, -867.395, 0] },
                            ],
                            ix: 1,
                            l: 2,
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0, 0.167, 0] },
                                    t: 12,
                                    s: [66.66, 66.6, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 16,
                                    s: [66.66, 90, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 21,
                                    s: [66.66, 66.8, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 39,
                                    s: [66.66, 66.8, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 41,
                                    s: [60, 66.8, 100],
                                },
                                {
                                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 47,
                                    s: [78, 66.8, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 52,
                                    s: [66.6, 66.8, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 65,
                                    s: [66.6, 66.8, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 66,
                                    s: [65.4, 66.6, 100],
                                },
                                {
                                    i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                                    o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                                    t: 69,
                                    s: [55.2, 61.2, 100],
                                },
                                { t: 70, s: [54, 59.4, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-387.395, -327.395], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 12,
                    op: 88,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 17,
                    ty: 4,
                    nm: 'shape 4',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 42,
                                    s: [1120, 560, 0],
                                    to: [26.667, 0, 0],
                                    ti: [-26.667, 0, 0],
                                },
                                { t: 45, s: [1280, 560, 0] },
                            ],
                            ix: 2,
                            l: 2,
                        },
                        a: { a: 0, k: [-251.483, 64.517, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [66.66, 66.66, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-251.483, 64.517], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 42,
                    op: 66,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 18,
                    ty: 4,
                    nm: 'shape 3',
                    sr: 1,
                    ks: {
                        o: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0.833], y: [0.833] },
                                    o: { x: [0.167], y: [0.167] },
                                    t: 11,
                                    s: [0],
                                },
                                { t: 13, s: [100] },
                            ],
                            ix: 11,
                        },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [1280, 1280, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [-251.483, 64.517, 0], ix: 1, l: 2 },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: { x: [0, 0, 0.667], y: [1, 1, 1] },
                                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                                    t: 11,
                                    s: [40, 40, 100],
                                },
                                { t: 13, s: [66.66, 66.66, 100] },
                            ],
                            ix: 6,
                            l: 2,
                        },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ty: 'rc',
                                    d: 1,
                                    s: { a: 0, k: [1080, 1080], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    r: { a: 0, k: 0, ix: 4 },
                                    nm: 'Rectangle Path 1',
                                    mn: 'ADBE Vector Shape - Rect',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [0.082352941176, 0.121568627451, 0.427450980392, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [-251.483, 64.517], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Rectangle 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 46,
                    st: 0,
                    ct: 1,
                    bm: 0,
                },
            ],
        },
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 0,
            nm: 'Shapes_Logo',
            refId: 'comp_0',
            sr: 0.63,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 0,
                            s: [-405],
                        },
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 7.754,
                            s: [-311],
                        },
                        {
                            i: { x: [0.833], y: [0.833] },
                            o: { x: [0.167], y: [0.167] },
                            t: 11.631,
                            s: [-315],
                        },
                        {
                            i: { x: [0.833], y: [0.833] },
                            o: { x: [0.167], y: [0.167] },
                            t: 12.6,
                            s: [-315],
                        },
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 15.508,
                            s: [-315],
                        },
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 23.262,
                            s: [-221],
                        },
                        {
                            i: { x: [0.833], y: [0.833] },
                            o: { x: [0.167], y: [0.167] },
                            t: 27.138,
                            s: [-225],
                        },
                        {
                            i: { x: [0.833], y: [0.833] },
                            o: { x: [0.167], y: [0.167] },
                            t: 28.108,
                            s: [-225],
                        },
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 31.015,
                            s: [-225],
                        },
                        {
                            i: { x: [0.667], y: [1] },
                            o: { x: [0.333], y: [0] },
                            t: 37.8,
                            s: [-131],
                        },
                        { t: 41.6767810997596, s: [-135] },
                    ],
                    ix: 10,
                },
                p: { a: 0, k: [278, 278, 0], ix: 2, l: 2 },
                a: { a: 0, k: [1280, 1280, 0], ix: 1, l: 2 },
                s: { a: 0, k: [16.6, 16.6, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 2560,
            h: 2560,
            ip: 0,
            op: 49,
            st: -6.78461538461538,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: 'Logo Outlines',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [1254, 263, 0], ix: 2, l: 2 },
                a: { a: 0, k: [960, 540, 0], ix: 1, l: 2 },
                s: { a: 0, k: [183.016, 183.016, 100], ix: 6, l: 2 },
            },
            ao: 0,
            shapes: [
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 0],
                                        [-17.746, 0],
                                        [-4.073, -17.456],
                                    ],
                                    o: [
                                        [4.074, -18.62],
                                        [17.747, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [-33.167, -15.856],
                                        [1.163, -44.076],
                                        [34.621, -15.856],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ind: 1,
                            ty: 'sh',
                            ix: 2,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 7.565],
                                        [50.041, 0],
                                        [0, -44.221],
                                        [-50.622, 0],
                                        [-11.827, 14.676],
                                        [0, 0],
                                        [17.164, 0],
                                        [4.947, 17.165],
                                        [0, 0],
                                    ],
                                    o: [
                                        [0, -37.821],
                                        [-44.221, 0],
                                        [0, 45.677],
                                        [33.41, 0],
                                        [0, 0],
                                        [-8.723, 10.796],
                                        [-18.329, 0],
                                        [0, 0],
                                        [0.582, -4.073],
                                    ],
                                    v: [
                                        [79.715, -3.055],
                                        [-0.001, -80.443],
                                        [-79.715, 0.145],
                                        [2.909, 80.443],
                                        [67.875, 52.892],
                                        [39.939, 24.894],
                                        [4.364, 40.876],
                                        [-32.585, 14.401],
                                        [78.551, 14.401],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 2',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'mm',
                            mm: 1,
                            nm: 'Merge Paths 1',
                            mn: 'ADBE Vector Filter - Merge',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [1547.347, 566.966], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 2',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 2,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 21.819],
                                        [-9.892, 0],
                                        [-3.491, -9.6],
                                        [0, 0],
                                        [31.421, 0],
                                        [0, -29.675],
                                        [0, -24.148],
                                        [11.055, 0],
                                        [4.073, 12.801],
                                        [0, 0],
                                        [-34.621, 0],
                                        [0, 31.712],
                                    ],
                                    o: [
                                        [0, -6.4],
                                        [10.182, 0],
                                        [0, 0],
                                        [-6.11, -21.529],
                                        [-38.694, 0],
                                        [0, 52.659],
                                        [0, 6.983],
                                        [-15.71, 0],
                                        [0, 0],
                                        [9.018, 26.766],
                                        [40.44, 0],
                                        [0, -56.441],
                                    ],
                                    v: [
                                        [-12.801, -34.911],
                                        [2.036, -45.094],
                                        [22.983, -30.549],
                                        [63.132, -46.258],
                                        [2.909, -80.297],
                                        [-60.223, -32.584],
                                        [19.783, 32.584],
                                        [2.909, 43.931],
                                        [-27.057, 23.857],
                                        [-67.205, 39.276],
                                        [1.163, 80.297],
                                        [67.205, 29.385],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [1387.048, 567.112], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 3',
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 3,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    o: [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [-24.293, 76.66],
                                        [24.293, 76.66],
                                        [24.293, -76.661],
                                        [-24.293, -76.661],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [1275.769, 566.967], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 4',
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 4,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [17.165, 0],
                                        [0, -17.456],
                                        [-17.165, 0],
                                        [0, 17.456],
                                    ],
                                    o: [
                                        [-17.165, 0],
                                        [0, 17.456],
                                        [17.165, 0],
                                        [0, -17.456],
                                    ],
                                    v: [
                                        [0.67, -29.82],
                                        [-31.218, 0.146],
                                        [0.67, 29.82],
                                        [31.218, 0.146],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [1275.245, 439.829], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 5',
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 5,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [20.948, 0],
                                        [0, 21.529],
                                        [-21.238, 0],
                                        [0, -21.819],
                                    ],
                                    o: [
                                        [-21.238, 0],
                                        [0, -22.111],
                                        [21.239, 0],
                                        [0, 22.111],
                                    ],
                                    v: [
                                        [0.145, 37.239],
                                        [-35.057, 0],
                                        [0.145, -37.24],
                                        [35.057, -0.292],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ind: 1,
                            ty: 'sh',
                            ix: 2,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [49.167, 0],
                                        [0, -45.968],
                                        [-48.877, 0],
                                        [0, 45.676],
                                    ],
                                    o: [
                                        [-48.877, 0],
                                        [0, 45.676],
                                        [49.167, 0],
                                        [0, -45.968],
                                    ],
                                    v: [
                                        [-0.145, -80.297],
                                        [-83.934, 0],
                                        [-0.145, 80.297],
                                        [83.934, 0],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 2',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'mm',
                            mm: 1,
                            nm: 'Merge Paths 1',
                            mn: 'ADBE Vector Filter - Merge',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [1145.886, 567.112], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 6',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 6,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    o: [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [-24.293, 106.336],
                                        [24.292, 106.336],
                                        [24.292, -106.336],
                                        [-24.293, -106.336],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [1016.394, 537.292], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 7',
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 7,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [21.237, 0],
                                        [0, 21.82],
                                        [-20.366, 0],
                                        [0, -22.402],
                                    ],
                                    o: [
                                        [-20.656, 0],
                                        [0, -21.82],
                                        [21.237, 0],
                                        [0, 22.111],
                                    ],
                                    v: [
                                        [0.728, 36.076],
                                        [-34.475, -1.454],
                                        [0.728, -39.275],
                                        [36.221, -1.454],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ind: 1,
                            ty: 'sh',
                            ix: 2,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [0, 0],
                                        [18.91, 0],
                                        [0, -45.967],
                                        [-44.513, 0],
                                        [-10.763, 11.347],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    o: [
                                        [-10.763, -10.765],
                                        [-44.513, 0],
                                        [0, 45.968],
                                        [18.91, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                    ],
                                    v: [
                                        [37.966, -62.258],
                                        [-6.254, -78.842],
                                        [-82.77, -1.454],
                                        [-6.254, 78.843],
                                        [37.966, 61.096],
                                        [37.966, 75.061],
                                        [82.77, 75.061],
                                        [82.77, -78.26],
                                        [37.966, -78.26],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 2',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'mm',
                            mm: 1,
                            nm: 'Merge Paths 1',
                            mn: 'ADBE Vector Filter - Merge',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [877.29, 568.566], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 8',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 8,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
                {
                    ty: 'gr',
                    it: [
                        {
                            ind: 0,
                            ty: 'sh',
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [20.365, 0],
                                        [0, 22.111],
                                        [-21.529, 0],
                                        [0, -21.82],
                                    ],
                                    o: [
                                        [-21.238, 0],
                                        [0, -22.402],
                                        [20.365, 0],
                                        [0, 21.82],
                                    ],
                                    v: [
                                        [-0.582, 65.46],
                                        [-36.366, 27.93],
                                        [-0.582, -9.891],
                                        [34.621, 27.93],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 1',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ind: 1,
                            ty: 'sh',
                            ix: 2,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [44.222, 0],
                                        [11.055, -9.31],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-18.328, 0],
                                        [0, 45.968],
                                    ],
                                    o: [
                                        [-16.583, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [11.056, 10.764],
                                        [44.513, 0],
                                        [0, -45.967],
                                    ],
                                    v: [
                                        [7.564, -52.367],
                                        [-34.039, -38.112],
                                        [-34.039, -108.227],
                                        [-82.624, -108.227],
                                        [-82.624, 104.445],
                                        [-37.821, 104.445],
                                        [-37.821, 91.352],
                                        [6.4, 108.227],
                                        [82.625, 27.93],
                                    ],
                                    c: true,
                                },
                                ix: 2,
                            },
                            nm: 'Path 2',
                            mn: 'ADBE Vector Shape - Group',
                            hd: false,
                        },
                        {
                            ty: 'mm',
                            mm: 1,
                            nm: 'Merge Paths 1',
                            mn: 'ADBE Vector Filter - Merge',
                            hd: false,
                        },
                        {
                            ty: 'fl',
                            c: { a: 0, k: [0.082352941176, 0.121568634931, 0.427451010311, 1], ix: 4 },
                            o: { a: 0, k: 100, ix: 5 },
                            r: 1,
                            bm: 0,
                            nm: 'Fill 1',
                            mn: 'ADBE Vector Graphic - Fill',
                            hd: false,
                        },
                        {
                            ty: 'tr',
                            p: { a: 0, k: [695.899, 539.182], ix: 2 },
                            a: { a: 0, k: [0, 0], ix: 1 },
                            s: { a: 0, k: [100, 100], ix: 3 },
                            r: { a: 0, k: 0, ix: 6 },
                            o: { a: 0, k: 100, ix: 7 },
                            sk: { a: 0, k: 0, ix: 4 },
                            sa: { a: 0, k: 0, ix: 5 },
                            nm: 'Transform',
                        },
                    ],
                    nm: 'Group 9',
                    np: 4,
                    cix: 2,
                    bm: 0,
                    ix: 9,
                    mn: 'ADBE Vector Group',
                    hd: false,
                },
            ],
            ip: 0,
            op: 49,
            st: -55,
            ct: 1,
            bm: 0,
        },
    ],
    markers: [],
});
